module.exports = __webpack_public_path__ + "img/start.ce9f1ed9.svg";